import React from 'react';

const InsightCardDetailPanel = ({ insight, onClose }) => {
  if (!insight) return null;
  return (
    <div className="insight-card-detail-panel">
      <button className="close-btn" onClick={onClose}>Fermer</button>
      <h2>{insight.title}</h2>
      <div className="context">Contexte : {insight.category}</div>
      <div className="analysis">Analyse :<br />{insight.explanation}</div>
      <div className="impact">Impact : {insight.impactScore}</div>
      <div className="pedagogy">Que signifie cela ?<br />{insight.summary}</div>
      <div className="consider">À considérer :<br />Voir recommandations dans l’explication.</div>
    </div>
  );
};

export default InsightCardDetailPanel;
